import { FieldTypes } from '../../types/fieldTypes.ts';
import type { Fields } from '../../types/index.ts';
import { yesNoOptions as options } from './options.ts';

// https://www.gdsuite.it/laravel/v1/visita/data?pk_id_pt=37392&pk_id_vt=26030&group=300
export const step3: Fields = [
  {
    code: 301,
    name: 'Lattosio',
    type: FieldTypes.radio,
    options,
    group: 300,
  },
  {
    code: 302,
    name: 'Glutine (Celiachia)',
    type: FieldTypes.radio,
    options,
    group: 300,
  },
  {
    code: 303,
    name: 'Nichel',
    type: FieldTypes.radio,
    options,
    group: 300,
  },
  {
    code: 304,
    name: 'Fruttosio',
    type: FieldTypes.radio,
    options,
    group: 300,
  },
];
